let allVideo = [
  {
    id: 0,
    name: "All",
    videos: [],
  },
  {
    id: 1,
    name: "Quick setup tutorials",
    videos: [
      {
        id: 1,
        name: "Deeper Connect Mini",
        url: "https://cdn.shopify.com/videos/c/o/v/851b9fe105dd4c36b6eab6b38131430b.mp4",
        cover:
          "https://cdn.shopify.com/s/files/1/0256/1038/7504/files/video-mini-bg.png?v=1739762961",
      },
      {
        id: 2,
        name: "Deeper Connect Air",
        url: "https://cdn.shopify.com/videos/c/o/v/0383da1dacdd4d5d9809857e64929e6e.mp4",
        cover:
          "https://cdn.shopify.com/s/files/1/0256/1038/7504/files/video-air-bg_7e4ffb6f-e689-46ce-adb0-23e3edd58ac6.png?v=1739762961",
      },
      {
        id: 3,
        name: "Deeper Connect Pico",
        url: "https://cdn.shopify.com/videos/c/o/v/44c80da1989c4dbab278a7a899e5a0ad.mp4",
        cover:
          "https://cdn.shopify.com/s/files/1/0256/1038/7504/files/video-pico-bg.png?v=1739762961",
      },
      {
        id: 4,
        name: "DPR Mini SE",
        url: "https://cdn.shopify.com/videos/c/o/v/7ca3af4a3f6343a1b3e355b1d0cffa77.mp4",
        cover:
          "https://cdn.shopify.com/s/files/1/0256/1038/7504/files/video-se-bg.png?v=1739787696",
      },
    ],
  },
  {
    id: 2,
    name: "Advanced feature walkthroughs",
    subCategories: [
      {
        id: 21,
        name: "AtomOS 2.0",
        videos: [
          {
            id: 1,
            name: "New Feature Coming Soon",
            url: "https://cdn.shopify.com/videos/c/o/v/e152b7d16bac42c1bf928c30106b7754.mp4",
            cover:
              "https://cdn.shopify.com/s/files/1/0256/1038/7504/files/maxresdefault_e6fa17e0-1bc5-4c3e-b965-7efab3f16431.jpg?v=1739532282",
          },
          {
            id: 2,
            name: "AtomOS 2.0 - DPN",
            url: "https://cdn.shopify.com/videos/c/o/v/4eb486654f374a95bbdca94c22ec1aed.mp4",
            cover:
              "https://cdn.shopify.com/s/files/1/0256/1038/7504/files/maxresdefault_1.jpg?v=1739532282",
          },
          {
            id: 3,
            name: "AtomOS 2.0 - Access Control",
            url: "https://cdn.shopify.com/videos/c/o/v/87e37ff7e34146f8bfa50d1de0845193.mp4",
            cover:
              "https://cdn.shopify.com/s/files/1/0256/1038/7504/files/maxresdefault_2.jpg?v=1739532282",
          },
          {
            id: 4,
            name: "AtomOS 2.0 - Dashboard",
            url: "https://cdn.shopify.com/videos/c/o/v/0ef85ab96bfc4e859451b2da28c3f2ac.mp4",
            cover:
              "https://cdn.shopify.com/s/files/1/0256/1038/7504/files/maxresdefault_3.jpg?v=1739532282",
          },
        ],
      },
    ],
  },
  {
    id: 3,
    name: "Best practices and maintenance tips",
    videos: [
      {
        id: 1,
        name: "Product Comparision",
        url: "https://cdn.shopify.com/videos/c/o/v/03e973db4e26448fa9eaf9e7136aa63d.mp4",
        cover:
          "https://cdn.shopify.com/s/files/1/0256/1038/7504/files/product-comparision-video-img.jpg?v=1739762965",
      },
      {
        id: 2,
        name: "Deeper Brand Story",
        url: "https://cdn.shopify.com/videos/c/o/v/2eb3e554494b4a2da0536187091d5e9a.mp4",
        cover:
          "https://cdn.shopify.com/s/files/1/0256/1038/7504/files/deeper-brand-story.jpg?v=1739762966",
      },
      {
        id: 3,
        name: "Deeper Connect Air",
        url: "https://cdn.shopify.com/videos/c/o/v/0441f181dd5846e0b5e3eee450c9985c.mp4",
        cover:
          "https://cdn.shopify.com/s/files/1/0256/1038/7504/files/air-unboxing-video-img.jpg?v=1739762965",
      },
      {
        id: 4,
        name: "Deeper Connect Air Features",
        url: "https://cdn.shopify.com/videos/c/o/v/96e72680613e458b9eea817be7e22080.mp4",
        cover:
          "https://cdn.shopify.com/s/files/1/0256/1038/7504/files/air-feature-video-img.jpg?v=1739762965",
      },
      {
        id: 5,
        name: "Deeper Connect Air-Secure Connections on Public Wi-Fi",
        url: "https://cdn.shopify.com/videos/c/o/v/4effae6cbe904b7086fa9773d8d2e0c4.mp4",
        cover:
          "https://cdn.shopify.com/s/files/1/0256/1038/7504/files/air-video-img.jpg?v=1739762964",
      },
      {
        id: 6,
        name: "DPN VS VPN",
        url: "https://cdn.shopify.com/videos/c/o/v/d3e2a9d040e74f9595a73b5c88d2e0e0.mp4",
        cover:
          "https://cdn.shopify.com/s/files/1/0256/1038/7504/files/dpnvsvpn-video-img.jpg?v=1739762962",
      },
      {
        id: 7,
        name: "App Relocator Feature",
        url: "https://cdn.shopify.com/videos/c/o/v/a3015b555c5b419aa5e45972b7f10f74.mp4",
        cover: "https://cdn.shopify.com/s/files/1/0256/1038/7504/files/air-kol-img.jpg?v=1739762965",
      },
      {
        id: 8,
        name: "TikTok Ban? No Worries",
        url: "https://cdn.shopify.com/videos/c/o/v/d9219606cc664944848bd470023b5749.mp4",
        cover:
          "https://cdn.shopify.com/s/files/1/0256/1038/7504/files/tiktok-video-img.jpg?v=1739762963",
      },
    ],
  },
];

let currentCategory = null;
let currentSubCategory = null;

function initPage() {
  allVideo[0].videos = allVideo.slice(1).reduce((acc, category) => {
    if (category.subCategories) {
      return acc.concat(
        category.subCategories.reduce((subAcc, subCat) => {
          return subAcc.concat(subCat.videos);
        }, [])
      );
    }
    return acc.concat(category.videos);
  }, []);

  renderCategories();

  const urlParams = new URLSearchParams(window.location.search);
  const categoryParam = urlParams.get("category");

  if (categoryParam) {
    const formattedParam = categoryParam.replace(/-/g, " ").toLowerCase();

    const category = allVideo.find(
      (c) => c.name.toLowerCase() === formattedParam
    );

    if (category) {
      const categoryTab = document.querySelector(
        `.tab:nth-child(${allVideo.indexOf(category) + 1})`
      );
      if (categoryTab) {
        categoryTab.click();
        return;
      }
    }
  }

  showVideos(allVideo[0].id);
}

function renderCategories() {
  const tabContainer = document.getElementById("categoryTabs");
  if (!tabContainer) {
    return;
  }

  tabContainer.innerHTML = "";
  allVideo.forEach((category, index) => {
    const tab = document.createElement("div");
    tab.className = `tab ${index === 0 ? "active" : ""}`;
    tab.textContent = category.name;
    tab.onclick = () => {
      document
        .querySelectorAll(".tab")
        .forEach((t) => t.classList.remove("active"));
      tab.classList.add("active");
      currentCategory = category;

      const subTabContainer = document.getElementById("subCategoryTabs");
      if (category.subCategories) {
        renderSubCategories(category.subCategories);
        subTabContainer.style.display = "flex";
      } else {
        subTabContainer.style.display = "none";
        currentSubCategory = null;
        showVideos(category.id);
      }
    };
    tabContainer.appendChild(tab);
  });
}

function renderSubCategories(subCategories) {
  const subTabContainer = document.getElementById("subCategoryTabs");
  subTabContainer.innerHTML = "";
  subCategories.forEach((subCategory, index) => {
    const subTab = document.createElement("div");
    subTab.className = `sub-tab ${index === 0 ? "active" : ""}`;
    subTab.textContent = subCategory.name;
    subTab.onclick = () => {
      document
        .querySelectorAll(".sub-tab")
        .forEach((t) => t.classList.remove("active"));
      subTab.classList.add("active");
      currentSubCategory = subCategory;
      showVideos(currentCategory.id, subCategory.id);
    };
    subTabContainer.appendChild(subTab);
  });
  currentSubCategory = subCategories[0];
  showVideos(currentCategory.id, subCategories[0].id);
}

function showVideos(categoryId, subCategoryId = null) {
  const videoList = document.getElementById("videoList");
  videoList.innerHTML = "";

  let videos = [];
  if (categoryId === 0) {
    videos = allVideo[0].videos;
  } else {
    const category = allVideo.find((c) => c.id === categoryId);
    if (!category) return;

    if (subCategoryId && category.subCategories) {
      const subCategory = category.subCategories.find(
        (sc) => sc.id === subCategoryId
      );
      if (subCategory) {
        videos = subCategory.videos;
      }
    } else if (category.videos) {
      videos = category.videos;
    }
  }

  videos.forEach((video) => {
    const videoItem = document.createElement("div");
    videoItem.className = "video-item";

    const defaultCover = "https://picsum.photos/300/180";

    videoItem.innerHTML = `
        <img src="${video.cover}" alt="${video.name}" 
            onerror="this.onerror=null; this.src='${defaultCover}'">
        <div class="play-icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="70" height="70" viewBox="0 0 70 70" fill="none">
                <g filter="url(#filter0_bd_7503_665)">
                    <circle cx="30.648" cy="30.8938" r="29.6042" fill="white" fill-opacity="0.2" shape-rendering="crispEdges"/>
                    <circle cx="30.648" cy="30.8938" r="29.1042" stroke="url(#paint0_linear_7503_665)" shape-rendering="crispEdges"/>
                </g>
                <g filter="url(#filter1_b_7503_665)">
                    <path d="M41.7333 30.0284C42.3669 30.4131 42.3669 31.3751 41.7333 31.7598L22.4866 43.4472C21.853 43.832 21.0609 43.351 21.0609 42.5815L21.0609 19.2067C21.0609 18.4372 21.853 17.9562 22.4866 18.341L41.7333 30.0284Z" fill="white" fill-opacity="0.8"/>
                </g>
                <defs>
                    <filter id="filter0_bd_7503_665" x="-32.2469" y="-32.0011" width="125.79" height="125.79" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                        <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                        <feGaussianBlur in="BackgroundImageFix" stdDeviation="16.6453"/>
                        <feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur_7503_665"/>
                        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
                        <feOffset dx="4" dy="4"/>
                        <feGaussianBlur stdDeviation="2.5"/>
                        <feComposite in2="hardAlpha" operator="out"/>
                        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"/>
                        <feBlend mode="normal" in2="effect1_backgroundBlur_7503_665" result="effect2_dropShadow_7503_665"/>
                        <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_7503_665" result="shape"/>
                    </filter>
                    <filter id="filter1_b_7503_665" x="-12.2297" y="-15.0851" width="87.7288" height="91.9582" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                        <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                        <feGaussianBlur in="BackgroundImageFix" stdDeviation="16.6453"/>
                        <feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur_7503_665"/>
                        <feBlend mode="normal" in="SourceGraphic" in2="effect1_backgroundBlur_7503_665" result="shape"/>
                    </filter>
                    <linearGradient id="paint0_linear_7503_665" x1="1.0437" y1="1.28955" x2="60.2522" y2="60.4981" gradientUnits="userSpaceOnUse">
                        <stop stop-color="white"/>
                        <stop offset="1" stop-color="white" stop-opacity="0"/>
                    </linearGradient>
                </defs>
            </svg>
        </div>
        <div class="video-info">
            <div class="video-title">${video.name}</div>
        </div>
    `;
    videoItem.onclick = () => {
      openVideoModal(video);
    };
    videoList.appendChild(videoItem);
  });
}

function openVideoModal(video) {
  const modal = document.getElementById("videoModal");
  const videoPlayer = document.getElementById("videoPlayer");

  if (video.url.includes("player.bilibili.com")) {
    videoPlayer.innerHTML = `<iframe src="${video.url}" frameborder="0" allowfullscreen></iframe>`;
  } else {
    videoPlayer.innerHTML = `<video controls autoplay playsinline>
        <source src="${video.url}" type="video/mp4">
        您的浏览器不支持视频播放。
    </video>`;
  }

  modal.classList.add("active");

  document.body.style.overflow = "hidden";
}

function closeVideoModal() {
  const modal = document.getElementById("videoModal");
  const videoPlayer = document.getElementById("videoPlayer");

  modal.classList.remove("active");
  videoPlayer.innerHTML = "";

  document.body.style.overflow = "";
}

document.getElementById("videoModal").addEventListener("click", (e) => {
  if (e.target.id === "videoModal") {
    closeVideoModal();
  }
});

document.addEventListener("DOMContentLoaded", function () {
  initPage();
});

window.onload = function () {
  initPage();
};
